import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { AlertTriangleIcon, XIcon } from 'lucide-react';
import { useJournal } from '../../context/JournalContext';

/**
 * Global notice shown when a save is rejected (for example by Supabase RLS).
 * It never blocks the app: the local data stays intact and the user can retry.
 * Follows the same minimal toast style already used for the trash notice.
 */
export function SaveErrorToast() {
  const {
    syncStatus,
    syncError,
    retrySave
  } = useJournal();
  const [dismissed, setDismissed] = useState(false);

  // A new failure always shows the notice again.
  useEffect(() => {
    if (syncStatus === 'error') setDismissed(false);
  }, [syncStatus, syncError]);
  const open = syncStatus === 'error' && !dismissed;
  return <AnimatePresence data-id="element-341" data-mp="3dumys2eaebhb">
      {open && <motion.div role="alert" initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      duration: 0.2
    }} className="fixed bottom-5 left-1/2 z-[95] flex max-w-[92vw] -translate-x-1/2 items-start gap-3 rounded-xl border border-line bg-white px-4 py-3 shadow-pop" data-id="element-342" data-mp="3dtlow190bv16">
          <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0 text-neg" data-id="element-343" data-mp="ypulvt42o7n3" />
          <div className="min-w-0" data-id="element-344" data-mp="ty2tdd1cvrub">
            <p className="text-[12.5px] font-medium leading-relaxed text-ink" data-id="element-345" data-mp="tx1lfhfmzlgt">No se han guardado los cambios</p>
            <p className="mt-0.5 text-[12px] leading-relaxed text-ink-soft" data-id="element-346" data-mp="17ru5mt6h1ptq">
              {syncError ?? 'Inténtalo de nuevo en unos segundos.'}
            </p>
          </div>
          <button type="button" onClick={retrySave} className="shrink-0 rounded-lg bg-ink px-2.5 py-1.5 text-[12px] font-medium text-white transition-colors duration-150 hover:bg-black" data-id="element-347" data-mp="1hnf3qg8f65y7">
            Reintentar
          </button>
          <button type="button" onClick={() => setDismissed(true)} className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-ink-soft transition-colors duration-150 hover:bg-surface" aria-label="Cerrar aviso" data-id="element-348" data-mp="3eh8su0y1jt07">
            <XIcon className="h-3.5 w-3.5" data-id="element-349" data-mp="1rdhd7kmj2de2" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}